document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('RelatedProductModal');

    const open = () => {
        if (!modal) { console.warn('[related-modal] Modal element #RelatedProductModal not found.'); return; }
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    };

    const close = () => {
        if (!modal) return;
        modal.classList.add('hidden');
        document.body.style.overflow = '';
    };

    if (modal) {
        modal.querySelectorAll('[data-related-modal-close]').forEach(el => el.addEventListener('click', close));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }

    // For each Add-to-cart form on the page…
    document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
        // Find the *nearest* related flag (on the form or inside it)
        const containerWithFlag =
            form.matches('[data-has-related]') ? form : form.querySelector('[data-has-related]');
        const hasRelated = containerWithFlag && containerWithFlag.getAttribute('data-has-related') === 'true';

        if (!hasRelated) return; // nothing to do for this form

        // Find this form's buy button (first submit button inside the form)
        const buyBtn = form.querySelector('button[type="submit"][name="add"]');
        if (!buyBtn) return;

        // Intercept the form submit exactly once to show the modal
        const onSubmit = (e) => {
            // If the button is disabled, let Shopify handle it
            if (buyBtn.hasAttribute('disabled')) return;

            // If we have no modal, warn and skip interception so the cart still works
            if (!modal) {
                console.warn('[related-modal] Intercept skipped: #RelatedProductModal is missing.');
                return;
            }
            setTimeout(() => {
                open();
            }, 2000);

            // Wire the "continue without add-on" button to resume original submit
            const continueBtn = modal.querySelector('[data-related-continue]');
            if (continueBtn) {
                continueBtn.addEventListener('click', () => {
                    close();
                }, { once: true });
            }
        };

        form.addEventListener('submit', onSubmit, { once: true });
    });
});
